import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";

@Component({
  selector: "sig-tool-tip",
  templateUrl: "./tool-tip.component.html",
})
export class ToolTipComponent implements OnInit {
  @ViewChild("tooltipDano") tooltipDano!: TemplateRef<any>;

  constructor() {}

  ngOnInit() {}
}
